import React from 'react';
import UserItems from './userItems';
import Spinner from '../layout/spinner';
// import githubContext from '../../context/github/githubContext';
import { useContext } from 'react';
import githubContext from '../../context/github/githubContext';

const Users = () => {
  const GithubContext = useContext(githubContext);
  const { loading, users } = GithubContext;
  if (loading) {
    return <Spinner />;
  } else {
    return (
      <div style={userStyle}>
        {users.map((user) => (
          <UserItems key={user.id} user={user} />
        ))}
      </div>
    );
  }
};

const userStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridGap: '1rem',
};

export default Users;
